export default __webpack_public_path__ + "assets/sounds/ef421a797e3d29b6a318db4a21d8bb33.mp3";